module.exports = __webpack_public_path__ + "img/list.c820f67.svg";